export default __webpack_public_path__ + "static/media/q_wdt_c_1.96b7e814.mp3";